import React, {Component} from 'react';
import 'moment/locale/tr';
import {Button, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import Alert from "react-s-alert";
import DefaultModal from "../invoice/DefaultModal";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Select from "../../local_node_modules/react-select";
import {isValidDbsAuth} from "../../common/componentValidation";

class DBSAuthModal extends Component {

	constructor(props){
		super(props);
		this.state={
			disabledBtn:false,
			dbsAuth:{}
		};
		this.changeAuth = this.changeAuth.bind(this);
		this.save 		= this.save.bind(this);
	}

	componentWillMount() {
		this.getDBSAuth();
	}

	getDBSAuth(){
		let self = this;
		let params = {
			url: `/dbs/auth/getDBSAuth`,
			method: 'post'
		};
		request(params)
		.then(function (response) {
			let {captchaInfo,dbsAuth} = response.data;
			let {resultContainer} = captchaInfo;
			let {captcha,key} = resultContainer;
			if(!dbsAuth){
				dbsAuth = {recordId:-1}
			}
			dbsAuth["captchaKey"]=key;
			dbsAuth["saveChecked"]= !!(dbsAuth.username || dbsAuth.apiKey);
			self.setState({captcha,dbsAuth});
		}).catch(function (error) {
			self.props.toggleModal(false,false);
			showAxiosError(error);
		});
	}

	changeAuth(name,value){
		let dbsAuth = this.state.dbsAuth;
		dbsAuth[name]=value;
		this.setState({dbsAuth});
	}

	save(){
		let self = this;
		let dbsAuth = this.state.dbsAuth;
		let result = isValidDbsAuth(dbsAuth);
		let valid = result.valid;
		if (valid) {
			let params = {
				url: `/dbs/auth/saveDbsAuth/`+dbsAuth.recordId,
				method: 'post',
				data:dbsAuth
			};
			self.setState({disabledBtn:true});
			request(params)
			.then(function (response) {
				let data = response.data;
				console.log("data",data);
				self.setState({disabledBtn:false});
				Alert.success("Giriş işleminiz yapıldı. İşleminize devam edebilirsiniz.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.props.toggleModal(false,self.props.from==='dbsModal');
			}).catch(function (error) {
				self.setState({disabledBtn:false});
				showAxiosError(error);
			});
		}else{
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 4000,
				html: true
			});
		}
	}

	render(){
		return(
			<DefaultModal
				isOpen={this.props.modal}
				title="Defter Beyan Sistemi Kullanıcı Bilgileri"
				size="md"
				onCancel={()=>this.props.toggleModal(false,false)}
				disabled={this.state.disabledBtn}
				confirmBtnText="Giriş"
				onConfirm={this.save}>
				<Row style={{minHeight:'150px'}}>
					<Col sm={12} className="row">
						<Col sm={12}>
							<FormGroup row>
								<Label for="username" sm={12} style={{fontWeight:'bold'}}>Yöntem</Label>
								<Col sm={12}>
									<Select
										clearable={false}
										disabled={true}
										searchable={false}
										className="select-control"
										value={(this.state.dbsAuth && this.state.dbsAuth.loginType) ? this.state.dbsAuth.loginType : this.changeAuth("loginType",'ASSOS')}
										placeholder="Seçiniz..."
										onChange={(e)=>this.changeAuth("loginType",e.value)}
										options={[{value:'ASSOS',label:'Normal Giriş'}, {value:'API',label:'API ile giriş'}]}/>
								</Col>
							</FormGroup>
						</Col>
						{this.state.dbsAuth && this.state.dbsAuth.loginType === 'ASSOS' &&
						<React.Fragment>
							<Col sm={12}>
								<FormGroup row>
									<Label for="username" sm={12} style={{fontWeight:'bold'}}>Kullanıcı Adı</Label>
									<Col sm={12}>
										<Input type="text"
											   id="username"
											   className="form-control"
											   style={{border:'0.1em solid #000'}}
											   placeholder="İnternet Vergi Dairesi Kullanıcı Kodu"
											   value={this.state.dbsAuth && this.state.dbsAuth.username ? this.state.dbsAuth.username : ''}
											   onChange={(e)=>this.changeAuth("username",e.target.value)}/>
									</Col>
								</FormGroup>
							</Col>
							<Col sm={12}>
								<FormGroup row>
									<Label for="password" sm={12} style={{fontWeight:'bold'}}>Şifre</Label>
									<Col sm={12}>
										<Input type="password"
											   id="password"
											   className="form-control"
											   style={{border:'0.1em solid #000'}}
											   placeholder="İnternet Vergi Dairesi Şifresi"
											   value={this.state.dbsAuth && this.state.dbsAuth.password ? this.state.dbsAuth.password : ''}
											   onChange={(e)=>this.changeAuth("password",e.target.value)}/>
									</Col>
								</FormGroup>
							</Col>
						</React.Fragment>
						}
						{this.state.dbsAuth && this.state.dbsAuth.loginType === 'API' &&
						<React.Fragment>
							<Col sm={12}>
								<FormGroup row>
									<Label for="apiKey" sm={12} style={{fontWeight:'bold'}}>Api Key</Label>
									<Col sm={12}>
										<Input type="text"
											   id="apiKey"
											   style={{border:'0.1em solid #000'}}
											   className="form-control"
											   placeholder="Dış sistem  Api Key Bilgisi"
											   value={this.state.dbsAuth ? this.state.dbsAuth.apiKey : ''}
											   onChange={(e)=>this.changeAuth("apiKey",e.target.value)}/>
									</Col>
								</FormGroup>
							</Col>
							<Col sm={12}>
								<FormGroup row>
									<Label for="apiSecret" sm={12} style={{fontWeight:'bold'}}>Api Secret Bilgisi</Label>
									<Col sm={12}>
										<Input type="text"
											   id="apiSecret"
											   style={{border:'0.1em solid #000'}}
											   className="form-control"
											   placeholder="Dış sistem Api Secret bilgisi"
											   value={this.state.dbsAuth ? this.state.dbsAuth.apiSecret : ''}
											   onChange={(e)=>this.changeAuth("apiSecret",e.target.value)}/>
									</Col>
								</FormGroup>
							</Col>
						</React.Fragment>
						}
						<Col sm={12} className="row">
							<Col sm={4}>
								<img src={"data:image/png;base64, " + this.state.captcha} alt="Captcha" style={{marginTop:'4px'}}/>
								<span className="">
									<Button color="link" size="sm" onClick={this.getCaptcha}>
										<i className="fas fa-refresh" style={{marginRight:'6px'}}/>Değiştir
									</Button>
								</span>
							</Col>
							<Col sm={8}>
								<FormGroup row>
									<Label for="apiSecret" sm={12} style={{fontWeight:'bold'}}>Resimdeki Sayıyı Giriniz</Label>
									<Col sm={12}>
										<Input type="text"
											   id="captcha"
											   style={{border:'0.1em solid #000'}}
											   className="form-control"
											   placeholder="Resimdeki Sayıyı Giriniz"
											   value={this.state.dbsAuth ? this.state.dbsAuth.captcha : ''}
											   onChange={(e)=>this.changeAuth("captcha",e.target.value)}/>
									</Col>
								</FormGroup>
							</Col>
						</Col>
						<Col sm={12}>
							<FormGroup row style={{float:'right'}}>
								<Input type="checkbox"
									   id="saveChecked"
									   checked={this.state.dbsAuth.saveChecked}
									   onChange={(e)=>this.changeAuth("saveChecked",e.target.checked)}/>
									<Label for="saveChecked" sm={11} style={{whiteSpace: 'nowrap'}}>Kullanıcı bilgilerini kaydet</Label>
							</FormGroup>
						</Col>
					</Col>
				</Row>
			</DefaultModal>
		);
	}
}

export default DBSAuthModal;

